// extracted by mini-css-extract-plugin
export default {"tabletImg":"CE","desktopImg":"EE","mobileImg":"FE","backgroundImage":"GE","content":"HE","rtbLeft":"IE","rtbRight":"JE","imageContainer":"KE","rtbBox":"LE","line":"ME"};
    if(module.hot) {
      // 1715276856627
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  